import { render, staticRenderFns } from "./statusBadge.vue?vue&type=template&id=1e3f07b0&"
import script from "./statusBadge.vue?vue&type=script&lang=js&"
export * from "./statusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports